import { Component, OnInit, Inject } from '@angular/core';
import { EventService } from 'src/app/services/event.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUtil } from 'src/app/objects/fileUtil';
import { GGKResponse } from 'src/app/objects/ggkResponse';
import { Payout } from 'src/app/objects/payouts';
import { catchError, finalize } from 'rxjs/operators';

@Component({
  selector: 's18-set-payout-dialog',
  templateUrl: './set-payout-dialog.component.html',
  styleUrls: ['./set-payout-dialog.component.scss']
})
export class SetPayoutDialogComponent implements OnInit {
  group_event_id: number;
  round_type: number;
  flighted: boolean;
  number_of_spots: number;
  payouts: Payout[];
  selectedPayout: Payout;
  title: string = "Prize Fund";
  saving: boolean = false;
  error: string = "";
  flight: string = "";


  constructor(
    private eventService: EventService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<SetPayoutDialogComponent>,
    private fileUtil: FileUtil,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.group_event_id = +data.group_event_id;
    this.round_type = data.round_type;
    this.flighted = data.flighted;
    this.number_of_spots = +data.number_of_spots;
    this.flight = data.flight ? data.flight : "0";
    this.title = ((this.round_type == 0) ? "Gross " : "Net ") + this.title + " - Flight " + this.getFlightLetter(this.flight);
    console.log(data)
  }

  ngOnInit() {
    this.getAllPayoutsForEvent();
  }

  getAllPayoutsForEvent() {
    this.eventService.getPayoutForEvent(this.group_event_id, this.number_of_spots, this.round_type)
      .subscribe(resp => {
        var ggk_response = JSON.parse(resp.d).response;
        console.log(ggk_response);
        if (ggk_response.status === 1) {
          this.payouts = JSON.parse(ggk_response.data).payouts;
          this.payouts.forEach((payout) => {
            if (this.number_of_spots > 1) {
              payout.payouts = (payout.pay_type == 0) ? payout.pay_percentage.split(',').map(x => +x) : payout.pay_amount.split(',').map(x => +x);
            }
            else {
              payout.payouts = [];
              payout.payouts.push(
                (payout.pay_type == 0) ? +payout.pay_percentage : +payout.pay_amount
              );
            }
          })
          this.selectedPayout = this.payouts[0];
        }
        console.log(this.payouts);
      });
  }

  loadFlightPayouts(event) {
    console.log(event);
  }

  save() {
    this.saving = true;
    this.error = "";
    this.eventService.savePayoutForFlight(
      this.group_event_id,
      this.number_of_spots,
      this.selectedPayout.pay_type,
      this.round_type,
      this.selectedPayout.payouts.join(","),
      this.flight)
      .pipe(
        catchError(err => {
          return err;
        }),
        finalize(() => {
          this.saving = false;
        })
      )
      .subscribe(resp => {
        var ggk_response = JSON.parse(resp.d).response;
        console.log(ggk_response);
        if (ggk_response.status === 1) { //success
          this.close(ggk_response.data);
        }
        else {
          this.error = ggk_response.data;
        }
      });
  }

  close(resp) {
    this.dialogRef.close(resp);
  }

  trackByFn(index, item) {
    return index;
  }

  getFlightLetter(flight: string): string {
    var f = +flight;
    switch (f) {
      case 0:
        return 'All';
      case 1:
        return 'A';
      case 2:
        return 'B';
      case 3:
        return 'C';
      case 4:
        return 'D';
      case 5:
        return 'E';
      case 6:
        return 'F';
      case 7:
        return 'G';
      case 8:
        return 'H';
    }
  }

}
